import React from 'react';
import { Row, Col } from 'reactstrap';
import { PortRestrictionsTable } from '../../../../../../../../../Components/PortRestriction';
import { SectionCard } from '../../../../../../../../../shared/offer-domain/ui';
import CounterNegotiationCard from '../../../../../../../../../shared/offer-domain/counter/CounterNegotiationCard';
import {
  formatDateTime,
  formatOperationalTolerance,
  hasOperationalToleranceCounter,
  hasProposalValidityCounter,
  isValidOperationalToleranceValue,
  resolveOperationalToleranceOption,
} from '../../../../../../../../../shared/offer-domain/counter';
import { formatProposalDeadline } from '../../../../../../../utils/tenderEvaluationHelpers';
import {
  TYPE_RESPONSE_TOLERANCE,
  TYPE_RESPONSE_VALIDITY,
  TYPE_RESPONSE_GLOBAL,
} from '../../../../../../../../../shared/offer-domain/respond';
import ClauseCard from './ClauseCard';

const GLOBAL_NOTES_KEY = TYPE_RESPONSE_GLOBAL;

const OfferPatternSections = ({ procurement, typeResponses = {} }) => {
  const hasToleranceCounter = hasOperationalToleranceCounter(
    procurement?.operationalToleranceCounter,
    procurement?.operationalToleranceOptionsCounter,
    procurement?.operationalToleranceOptionsCounterLabel
  );
  const hasValidityCounter = hasProposalValidityCounter(
    procurement?.proposalValidityPeriodMaxCounter
  );
  const toleranceOption = resolveOperationalToleranceOption({
    label: procurement?.operationalToleranceOptionsCounterLabel,
    optionsCounter: procurement?.operationalToleranceOptionsCounter,
  });

  const validityHistory = typeResponses?.[TYPE_RESPONSE_VALIDITY] ?? [];
  const toleranceHistory = typeResponses?.[TYPE_RESPONSE_TOLERANCE] ?? [];
  const globalResponses = typeResponses?.[GLOBAL_NOTES_KEY] ?? [];

  const hasValidityHistory = validityHistory.length > 0;
  const hasToleranceHistory = toleranceHistory.length > 0;

  return (
    <>
      <Row className='mb-4'>
        <Col sm={12}>
          <CounterNegotiationCard
            title='Validity Period'
            subtitle='Review validity period requirements'
            label='Valid To (Jakarta Local Time)'
            currentDisplay={formatDateTime(
              procurement?.proposalValidityPeriodMax
            )}
            extraFields={[
              {
                label: 'Submission Deadline (Jakarta Local Time)',
                value: formatProposalDeadline(
                  procurement?.proposalSubmissionDeadline
                ),
              },
            ]}
            counterDisplay={
              hasValidityCounter
                ? formatDateTime(procurement?.proposalValidityPeriodMaxCounter)
                : null
            }
            hasCounter={hasValidityCounter}
            historyItems={validityHistory}
            isExpanded={hasValidityCounter || hasValidityHistory}
            onToggleExpand={() => {}}
            editable={false}
            isEvaluatorView={false}
            isRespondClosed
          />
        </Col>
      </Row>

      <Row className='mb-4'>
        <Col sm={12}>
          <CounterNegotiationCard
            title='Operational Tolerance'
            subtitle='Review operational tolerance requirements'
            partyType={procurement?.partyType}
            label='Operational Tolerance'
            currentDisplay={formatOperationalTolerance(
              procurement?.operationalTolerance
            )}
            counterDisplay={
              isValidOperationalToleranceValue(
                procurement?.operationalToleranceCounter
              )
                ? formatOperationalTolerance(
                    procurement?.operationalToleranceCounter
                  )
                : null
            }
            partyTypeCounter={toleranceOption || null}
            hasCounter={hasToleranceCounter}
            historyItems={toleranceHistory}
            isExpanded={hasToleranceCounter || hasToleranceHistory}
            onToggleExpand={() => {}}
            editable={false}
            isEvaluatorView={false}
            isRespondClosed
          />
        </Col>
      </Row>

      <SectionCard>
        <Row>
          <Col sm={12}>
            <div className='border-start border-2 border-primary ps-3 mb-3'>
              <div className='text-muted small fw-semibold mb-2'>Notes</div>
              {procurement?.globalNotes ? (
                <div
                  className='html-content-panel'
                  style={{ backgroundColor: '#fff' }}
                >
                  <div
                    className='html-content-body'
                    dangerouslySetInnerHTML={{
                      __html: procurement.globalNotes,
                    }}
                  />
                </div>
              ) : (
                <div className='text-dark fs-13 mb-0 lh-base'>-</div>
              )}
            </div>
          </Col>
        </Row>
        {globalResponses.length > 0 && (
          <Row className='mt-2'>
            <ClauseCard
              clause={{
                id: GLOBAL_NOTES_KEY,
                clauseTitle: 'Notes Clarification',
                clauseDescription: '',
              }}
              clauseResponses={{ [GLOBAL_NOTES_KEY]: globalResponses }}
            />
          </Row>
        )}
        <hr className='my-4 border-secondary border-dashed' />
        <div className='mt-2'>
          <h5 className='fw-bold text-dark mb-3'>Port Restrictions</h5>
          <PortRestrictionsTable
            ports={procurement?.portRestriction}
            procurementId={procurement?.id}
          />
        </div>
      </SectionCard>
    </>
  );
};

export default OfferPatternSections;
